import { type Key, t } from "../../i18n/index.ts";
import { PageHeader } from "../../ui/PageHeader.tsx";
import { TabNav } from "../../ui/TabNav.tsx";

/** The account pages: your profile, your organizations, where you're signed in, your privacy. */
const ACCOUNT_TABS: readonly [string, Key][] = [
  ["/profile", "account.tab.profile"],
  ["/profile/orgs", "account.tab.orgs"],
  ["/profile/sessions", "account.tab.sessions"],
  ["/profile/privacy", "account.tab.privacy"],
  ["/profile/device", "account.tab.device"],
];

/** Title and tabs shared by the account pages. */
export function AccountTabs({ current }: { current: string }) {
  return (
    <>
      <PageHeader title={t("account.title")} />
      <TabNav
        label={t("account.sections")}
        tabs={ACCOUNT_TABS.map(([href, label]) => ({ href, label: t(label), current: href === current }))}
      />
    </>
  );
}
